// extracted by mini-css-extract-plugin
export var modal = "_ix-0";